import { useNavigate } from 'react-router-dom';

import { Button } from '../../../GlobalComponents/Button';
import { Flex } from '../../../GlobalComponents/Flex';

export type ContinueProps = React.HTMLAttributes<HTMLDivElement> & {
	back?: boolean;
	backTo?: string;
	clickHandler?: () => void | Promise<boolean | void>;
	loading?: boolean;
	disableOrder?: boolean;
	continueLabel?: string;
	backLabel?: string;
};

export const Continue: React.FC<ContinueProps> = ({
	back,
	backTo,
	clickHandler,
	loading,
	disableOrder,
	continueLabel = 'Continue',
	backLabel = 'Back'
}) => {
	const navigate = useNavigate();

	return (
		<Flex
			$width="100%"
			$flexDirection="column"
			$columnGap="16px"
			$rowGap="16px"
			$margin="20px 0 1px 0"
		>
			{back && (
				<Button
					$width="100%"
					$border="1px solid #574D45"
					$backgroundColor="#574D45"
					$color="#FDFDFD"
					disabled={loading}
					$isLoading={loading}
					onClick={() => {
						backTo ? navigate(backTo) : navigate(-1);
						window.scrollTo({ top: 0, behavior: 'smooth' });
					}}
				>
					{backLabel}
				</Button>
			)}

			<Button
				$width="100%"
				disabled={disableOrder}
				$isLoading={loading}
				onClick={async () => {
					if (clickHandler) {
						await clickHandler();
					}
				}}
			>
				{continueLabel}
			</Button>
		</Flex>
	);
};
